<script setup>
import EditorImage from './EditorImage.vue';
const props = defineProps({
    editor: Object,
    imagable: Boolean,
});

const addImage = (url) => {
    if (url) {
        props.editor.chain().focus().setImage({ src: url }).run();
    }
};
</script>
<template>
    <div class="actions">
        <div class="group">
            <button @mousedown.prevent="editor.chain().focus().undo().run()">
                <Icon name="undo" class="icon" />
            </button>
            <button @mousedown.prevent="editor.chain().focus().redo().run()">
                <Icon name="redo" class="icon" />
            </button>

            <button @mousedown.prevent="editor.chain().focus().setParagraph().run()" :class="{ active: editor.isActive('paragraph') }">
                <Icon name="paragraph" class="icon" />
            </button>
            <button @mousedown.prevent="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ active: editor.isActive('heading', { level: 2 }) }">
                <Icon name="header" class="icon" />
            </button>

            <button @mousedown.prevent="editor.chain().focus().toggleBold().run()" :class="{ active: editor.isActive('bold') }">
                <Icon name="bold" class="icon" />
            </button>
            <button @mousedown.prevent="editor.chain().focus().toggleItalic().run()" :class="{ active: editor.isActive('italic') }">
                <Icon name="italic" class="icon" />
            </button>
            <button @mousedown.prevent="editor.chain().focus().toggleUnderline().run()" :class="{ active: editor.isActive('underline') }">
                <Icon name="underline" class="icon" />
            </button>

            <button @mousedown.prevent="editor.chain().focus().toggleBulletList().run()" :class="{ active: editor.isActive('bulletList') }">
                <Icon name="bullet" class="icon" />
            </button>
            <button @mousedown.prevent="editor.chain().focus().toggleOrderedList().run()" :class="{ active: editor.isActive('orderedList') }">
                <Icon name="list" class="icon" />
            </button>
            <EditorImage @mousedown.prevent @uploaded="addImage" v-if="props.imagable" />
            <button @mousedown.prevent="editor.chain().focus().setHorizontalRule().run()">
                <Icon name="line" class="icon" />
            </button>
        </div>
    </div>
</template>

<style scoped>
.actions {
    @apply flex py-2 px-4 gap-4 bg-white rounded-lg;
    box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.13);
}
.group {
    @apply flex gap-2;
}

.icon {
    @apply size-6;
}

.actions button {
    @apply p-1 cursor-pointer;
    line-height: 0;
}

.actions button:hover,
.actions button.active {
    @apply bg-gray-200 rounded transition duration-300 text-blue-500;
}
</style>
